<template>
  <div class="pricing-history-selector">
    <ul>
      <li
        v-for="i in maxPositions"
        :key="i"
        :class="{ active: i == activeIndex }"
      >
        <span @click="setActiveIndex(i)">{{ selectedOffset[i - 1] }}</span>
        <md-menu md-size="small">
          <span md-menu-trigger><md-icon>arrow_drop_down</md-icon></span>
          <md-menu-content>
            <md-menu-item
              v-for="j in 31"
              :key="j"
              @click="setSelectedOffset(i - 1, j)"
              >{{ getValueOf(j) }}</md-menu-item
            >
          </md-menu-content>
        </md-menu>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    maxPositions: {
      type: Number,
      default: 4
    }
  },
  data() {
    return {
      activeIndex: 1,
      selectedOffset: [-2, -3, -7, -15]
    };
  },
  methods: {
    setSelectedOffset(selector, value) {
      this.$set(this.selectedOffset, selector, this.getValueOf(value));
      this.setActiveIndex(selector + 1);
    },
    getValueOf(i) {
      return -31 + i - 1;
    },
    setActiveIndex(i) {
      this.activeIndex = i;
      this.$emit("offset-updated", this.selectedOffset[this.activeIndex - 1]);
    }
  }
};
</script>

<style lang="scss" scoped>
.pricing-history-selector {
  display: flex;
  position: relative;

  ul {
    padding: 0;
    display: flex;

    li {
      cursor: default;
      text-align: center;
      display: block;
      min-width: 55px;
      list-style: none;
      padding: 6px 12px;
      border: #ccc 1px solid;
      border-left: none;
      &:first-child {
        border-left: #ccc 1px solid;
        border-bottom-left-radius: 5px;
        border-top-left-radius: 5px;
      }
      &:last-child {
        border-bottom-right-radius: 5px;
        border-top-right-radius: 5px;
      }
      &.active,
      &.active .md-icon {
        background-color: var(--md-theme-default-primary);
        color: white;
      }
    }
  }
}
</style>
